import { motion } from "framer-motion";
import { ImageHeader,ImageHeaderHand,AvatarHeader, LandingImage,AvatarMobile } from "constants/images";
import { Link } from "react-router-dom";
import { CiClock2 } from "react-icons/ci";
import { FiBriefcase } from "react-icons/fi";
import React from "react";
import { PremiumBtn } from "constants/images";
import { FaStar } from "react-icons/fa";
import { FaArrowRight } from "react-icons/fa6";
import { useTranslation } from "react-i18next";

const animations = {
  initial: {
    opacity: 0,
    translateY: 25,
  },
  whileInView: {
    opacity: 1,
    translateY: 0,
  }
};

const animationsX = {
  initial: {
    opacity: 0,
    translateX: 25,
  },
  whileInView: {
    opacity: 1,
    translateX: 0,
  }
};

export default function Hero() {

  const [isTablet, setIsTablet] = React.useState(false);

  React.useEffect(() => {
    const updateDevice = () => {
      if (window.innerWidth <= 768) {
        setIsTablet(true);
      }else if (window.innerWidth <= 1024) {
        setIsTablet(true);
      } else {
        setIsTablet(false);
      }
    };

   updateDevice();
    window.addEventListener("resize", updateDevice);
    return () => window.removeEventListener("resize", updateDevice);
  }, []);

  return (
    // <div className="bg-[#0C6ED1] text-white text-center px-6">
    //   <div className="container m-auto">
    //     <div className="flex flex-wrap 2md:flex-nowrap w-full max-w-[86.25rem] mx-auto md:justify-between">
    //       <motion.div {...animationsX} transition={{ duration: 0.5, delay: 0.2}} className="relative flex justify-center 2md:justify-end w-full 2md:w-auto">
    //         <div className="flex items-end justify-center 2md:justify-end">
    //           <div className="relative w-full 2md:w-[85%]">
    //           <div className="absolute top-[67%] -left-2 md:-left-4 2smd:-left-4 lg:-left-[3rem]  w-auto z-50">
    //             <div className="px-1 md:px-4 py-1 md:py-2 rounded-md bg-white/30 backdrop-blur-md text-start relative">
    //               <h1 className="font-bold text-base md:text-xl 2smd:text-xl lg:text-xl xl:text-2xl inline-flex items-center gap-2">
    //                 Paul Balsillie
    //                 <span>
    //                   <svg
    //                     className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5 lg:w-6 lg:h-6"
    //                     viewBox="0 0 16 16"
    //                     fill="none"
    //                     xmlns="http://www.w3.org/2000/svg"
    //                   >
    //                     <path
    //                       d="M8.34047 15.5599H7.54172L5.66297 13.6249H2.88422L2.28797 13.0624V10.3399L0.386719 8.40492V7.60617L2.28797 5.67117V2.93742L2.88422 2.37492H5.66297L7.54172 0.451172H8.34047L10.2755 2.37492H13.0092L13.5717 2.92617V5.67117L15.4955 7.60617V8.40492L13.538 10.3399V13.0624L12.9755 13.6249H10.2755L8.34047 15.5599ZM6.48422 10.7899H7.28297L11.5242 6.54867L10.7255 5.74992L6.88922 9.59742L5.33672 8.04492L4.53797 8.84367L6.48422 10.7899Z"
    //                       fill="#0C6ED1"
    //                     />
    //                   </svg>
    //                 </span>
    //               </h1>

    //               <p className="flex items-center gap-2 mt-1">
    //                 <FiBriefcase className="text-white text-xs sm:text-sm md:text-base" />
    //                 <span className="inline-block text-[8px] sm:text-xs md:text-sm 2smd:text-xs lg:text-xs xl:text-sm">
    //                   Writer, Director, Actor, Comedian
    //                 </span>
    //               </p>
    //             </div>
    //           </div>
    //           <img src={isTablet ? ImageHeaderHand : ImageHeader} alt="header_image" className="fade-image object-cover"/>
    //           </div>
    //         </div>
    //       </motion.div>
    //       <div className="block 2md:flex justify-start items-center">
    //         <div className="w-full 2md:max-w-[43rem]">
    //           <motion.h1
    //             className="font-bold text-2xl md:text-4xl m-auto leading-tight text-center md:text-start mt-10 md:mt-12 2md-mt-0"
    //             {...animations}
    //             transition={{ duration: 0.5}}
    //           >
    //             {/* {t('showoffEverything')} */}
    //             “Half my work was impossible to find online… until I found Milestones Page.”
    //           </motion.h1>
    //           <motion.p {...animations} transition={{ duration: 0.5, delay: 0.1}} className="m-auto text-xs/6 md:text-base/7 font-light text-start mt-2">
    //             Join the growing number of actors, musicians, artists, filmmakers, comedians, and more
    //             who are building their Milestones Page to showcase their work quickly and easily, and connect with others.
    //           </motion.p>
    //           {/* <motion.div {...animations} transition={{ duration: 0.5, delay: 0.2}} className="h-[3.75rem] w-full relative bg-white/20 rounded-md mt-[1.75rem] flex flex-row items-center"> */}
    //           <motion.div {...animations} transition={{ duration: 0.5, delay: 0.2}} className="flex flex-col items-center 2md:block">
    //             <div className="mt-4 mb-2 flex justify-center md:justify-start w-full"
    //             >
    //               <Link
    //                 to="/plans"
    //                 className="px-8 py-3 rounded-md text-[.7rem] md:text-[0.9rem] bg-lightBlack/40 hover:bg-lightBlack/60 transition cursor-pointer inline-block w-full md:w-auto"
    //                 style={{backgroundImage: `url(${PremiumBtn})`,
    //                       backgroundSize:'cover',
    //                       backgroundPosition:'center center',
    //                       backgroundRepeat: 'no-repeat'
    //               }}
    //               >
    //                 Claim Lifetime Access Now
    //               </Link>
    //             </div>
    //             <div className="flex gap-2 justify-center md:justify-start items-center w-full mb-0 2smd:mb-4">
    //                 <CiClock2 className="text-[1rem] md:text-lg"/>
    //                 <div className="text-[.7rem] md:text-[.8rem] text-center">Lifetime Promo is valid until October 31st</div>
    //             </div>
    //           </motion.div> 
    //         </div>
    //       </div> 
    //     </div>
    //   </div>
    // </div>


    <div className="bg-black text-white text-center">
        <div className="flex flex-wrap 2md:flex-nowrap w-full mx-auto md:justify-between">
          <motion.div {...animationsX} transition={{ duration: 0.5, delay: 0.2}} className="relative flex justify-center 2md:justify-end w-full 2md:w-auto flex-1">
            <div className="flex items-end justify-center 2md:justify-end">
              <div className={`relative ${isTablet ? 'w-[100vw] h-[95vh] md:h-[80vh]' : 'w-[50vw] h-[70vh]'}`}
              style={{backgroundImage: `url(${isTablet ? AvatarMobile : LandingImage})`,
                          backgroundSize:isTablet ? 'contain' : 'cover',
                          backgroundPosition:isTablet ?  'top center' : 'center center',
                          backgroundRepeat: 'no-repeat'
                  }}
              >
                <div className="absolute inset-0 bg-black/50"></div>
                {
                  isTablet && 
                  <div className="flex items-end h-full bg-trasparent pb-12 relative z-10 px-4 md:px-8">
                    <Description isTablet={isTablet}/>
                  </div>
                }
              </div>
            </div>
          </motion.div>
          {
            !isTablet && 
            <div className="block 2md:flex justify-start items-center flex-1">
              <Description isTablet={isTablet}/>
            </div> 
          }
          
        </div> 
    </div>
  );
}

const Description = ({isTablet})=>{
  const { t } = useTranslation();

  return  (
    <>
      <div className={`${isTablet ? 'max-w-[100vw] md:max-w-[70vw]' : 'max-w-full 1xl:max-w-[30vw]'}`}>
        <motion.p {...animations} transition={{ duration: 0.5, delay: 0.1}} className="m-auto text-xs/6 md:text-base/7 font-bold text-start">
          Actors
        </motion.p>
        <motion.h1
          className="font-bold text-4xl md:text-5xl m-auto leading-tight text-start mt-4"
          {...animations}
          transition={{ duration: 0.5}}
        >
          Make them remember you after the audition.
        </motion.h1>
        <motion.p {...animations} transition={{ duration: 0.5, delay: 0.1}} className="m-auto text-xs/6 md:text-base/7 font-light text-start mt-4">
          While everyone else sends a list, wow them with photos, programs, reviews and proof.
        </motion.p>

        <motion.p {...animations} transition={{ duration: 0.5, delay: 0.1}} className="m-auto text-xs/6 md:text-base/7 font-bold text-start mt-4">
          <p>The portfolio built to get you cast.</p>
        </motion.p>

        <motion.div {...animations} transition={{ duration: 0.5, delay: 0.2}}>
          <div className="my-4 flex justify-start"
          >
            <a
              href={`${process.env.REACT_APP_PUBLIC_DOMAIN}/sign-up`}
              className="px-8 py-3 rounded-md text-[.7rem] md:text-[0.9rem] bg-[#0C6ED1] hover:bg-lightBlack/60 transition cursor-pointer inline-block w-full md:w-auto"
            >
              {t('joinNow', { defaultValue: 'Join For Free Today' })} <span className="inline-flex items-center text-sx"><FaArrowRight/></span>
            </a>
          </div>  
        </motion.div> 
          <motion.p {...animations} transition={{ duration: 0.5, delay: 0.1}} className="m-auto text-xs/6 md:text-base/7 font-light italic text-start mt-2">
          Half of who I was as an artist felt invisible online... until I built my Milestone Page.
          <div className="flex items-center gap-4 mt-2">
            <img src={AvatarHeader} alt="header_image" className="object-cover rounded-full w-[40px] h-[40px]"/> 
            <div>
              <div className="flex gap-1 text-[#f2994a]">
                <FaStar/>
                <FaStar/>
                <FaStar/>
                <FaStar/>
                <FaStar/>
              </div>
              <p>CJ Fortuna</p>
            </div>
          </div>
        </motion.p>

       
      </div>
    </> 
  )
}
